module.exports = __webpack_public_path__ + "img/logo.b6964e29.png";